<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px mr-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入隐患描述"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.hiddenDangerSource"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患来源"
          clearable
        >
          <el-option
            v-for="item in hiddenSourceList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择区域"
          v-model="searchData.areaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerlevel"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患等级"
          clearable
        >
          <el-option
            v-for="item in hiddenLevelList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerCategory"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患类别"
          clearable
        >
          <el-option
            v-for="item in hiddenCategoryList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="datePickerValue"
          format="yyyy-MM-dd HH:mm:ss"
          size="small"
          type="datetimerange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <!-- <el-date-picker
          class="mr-10px mb-10px !w-350px"
          v-model="datePickerValue"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker> -->
        <el-select
          v-model="searchData.hiddenDangerRectificationStatus"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择整改状态"
          clearable
        >
          <el-option
            v-for="item in hiddenDangerRectificationStatusList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <!-- <el-select
          v-model="searchData.ownedSystemOrUnit"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择所属系统/机组"
          clearable
        >
          <el-option
            v-for="item in ownedSystemOrUnitList"
            :key="item.id"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select> -->

        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="隐患描述"
            prop="hiddenDangerName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患等级"
            prop="hiddenDangerlevelStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患类别"
            prop="hiddenDangerCategoryStr"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            label="所在区域"
            prop="areaStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患来源"
            prop="hiddenDangerSourceStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="所属机组/系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="状态"
            prop="hiddenDangerRectificationStatusStr"
            min-width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.hiddenDangerRectificationStatusStr === '超期未整改' ? 'danger' : ''
                "
                size="small"
              >
                {{ scope.row.hiddenDangerRectificationStatusStr }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="隐患类型"
            prop="hiddenDangerTypeStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>  -->
          <el-table-column
            label="安全检查标题"
            prop="safetyInspectionTitle"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="安全检查期数"
            prop="safetyInspectionPeriods"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患整改负责人"
            prop="personChargeHiddenDangerRectificationName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="开始整改时间"
            prop="startRectificationTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.startRectificationTime
                  ? dayjs(scope.row.startRectificationTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="完成整改时间"
            prop="startRectificationCompletionTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.startRectificationCompletionTime
                  ? dayjs(scope.row.startRectificationCompletionTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="隐患整改期限"
            prop="hiddenDangerRectificationPeriod"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.hiddenDangerRectificationPeriod
                  ? dayjs(scope.row.hiddenDangerRectificationPeriod).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <!-- 510 -->
          <el-table-column label="操作" fixed="right" width="300">
            <!-- hiddenDangerRectificationStatus -->
            <!-- 隐患整改状态（0：待整改；1：整改中；2：已整改；3：超期未整改；4：延期审核中） -->
            <template slot-scope="scope">
              <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
              <!-- <el-button
            size="mini"
            :disabled="!$hasAccess('single')"
            @click="handleEvent(scope.row, 'single')"
            >整改单</el-button
          > -->
              <!-- 待整改 -->
              <!-- 整改驳回配置一个权限 -->
              <!-- <el-button
            size="mini"
            :disabled="
              !($hasAccess('rectification') && scope.row.hiddenDangerRectificationStatus === 0)
            "
            @click="handleEvent(scope.row, 'rectification')"
            >整改</el-button
          ><el-button
            size="mini"
            :disabled="
              !($hasAccess('rectification') && scope.row.hiddenDangerRectificationStatus === 0)
            "
            @click="handleEvent(scope.row, 'rectification')"
            >驳回</el-button
          > -->

              <!-- 整改中 -->
              <!-- <el-button
            size="mini"
            :disabled="!($hasAccess('accpet') && scope.row.hiddenDangerRectificationStatus === 1)"
            @click="handleEvent(scope.row, 'accpet')"
            >验收</el-button
          ><el-button
            size="mini"
            :disabled="!($hasAccess('delay') && scope.row.hiddenDangerRectificationStatus === 1)"
            @click="handleEvent(scope.row, 'delay')"
            >延期</el-button
          > -->

              <!-- 超期未整改 -->
              <!-- <el-button
            size="mini"
            :disabled="!($hasAccess('delay') && scope.row.hiddenDangerRectificationStatus === 3)"
            @click="handleEvent(scope.row, 'delay')"
            >延期</el-button
          > -->

              <!-- 延期审核中 -->
              <!-- <el-button
            size="mini"
            :disabled="!($hasAccess('audit') && scope.row.hiddenDangerRectificationStatus === 4)"
            @click="handleEvent(scope.row, 'audit')"
            >审核</el-button
          >

          <el-button
            size="mini"
            @click.native="handleEvent(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >查看</el-button
          > -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <HiddenRectificationForm
      v-if="formDialog"
      :formProps="formProps"
      :FormData="FormData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    />
    <ChangeSingle :formData="FormData" v-if="isSingle" @cancel="isSingle = false"></ChangeSingle>
    <!-- 延期驳回 -->
    <!-- <HiddenRejectDialog
      title="延期驳回"
      v-if="showPostponeDialog"
      @handleOk="handlePostponeRejectOk"
      @cancel="showPostponeDialog = false"
    ></HiddenRejectDialog> -->
    <!-- 驳回 -->
    <HiddenRejectDialog
      v-if="showDialog"
      @handleOk="handleRejectOk"
      @cancel="showDialog = false"
    ></HiddenRejectDialog>
    <!-- 开始整改 -->
    <RectificationForm
      v-if="showForm"
      :id="FormData.id"
      :propsFormData="FormData"
      @handleOk="handleFormOk"
      @cancel="showForm = false"
    ></RectificationForm>
    <!-- 延期 -->
    <DelayForm
      v-if="showDelayForm"
      :FormData="FormData"
      @handleOk="handleDelayFormOk"
      @cancel="showDelayForm = false"
    ></DelayForm>
  </el-card>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import axios from 'axios'
import qs from 'qs'
import utils from '@/components/safety/enumField/utils'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import HiddenRectificationForm from '../../components/HiddenRectification/HiddenRectificationForm'
import ChangeSingle from '../../components/HiddenRectification/ChangeSingle'

import HiddenRejectDialog from '../../components/business/HiddenRejectDialog'
import RectificationForm from '../../components/HiddenRectification/RectificationForm'
import DelayForm from '../../components/HiddenRectification/DelayForm'

const areaApi = new AreaApi()

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'hidden-rectification',
  components: {
    HiddenRectificationForm,
    ChangeSingle,
    TableOperateButton,
    HiddenRejectDialog,
    RectificationForm,
    DelayForm,
  },
  data() {
    return {
      showDelayForm: false,
      showForm: false,
      showDialog: false,
      showPostponeDialog: false,

      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],
      hiddenDangerRectificationStatusList: [
        // { displayName: '待整改', code: 0 },
        { displayName: '整改中', code: 1 },
        // { displayName: '已整改', code: 2 },
        { displayName: '超期未整改', code: 3 },
        { displayName: '延期审核中', code: 4 },
      ],

      FormData: {},
      formDialog: false,
      detailDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],

      // 整改单
      cardDetail: {},
      isSingle: false,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          // 不变
          {
            text: '整改单',
            click: () => {
              return this.handleEvent(val, 'single')
            },
            isShow: this.$hasAccess('single') && val.hiddenDangerRectificationStatus !== 0,
          },
          // {
          //   text: '整改',
          //   click: () => {
          //     return this.handleEvent(val, 'rectification')
          //   },
          //   isShow:
          //     this.$hasAccess('rectification') &&
          //     val.hiddenDangerRectificationStatus === 0 &&
          //     val.auditPermission,
          // },
          {
            text: '审核',
            click: () => {
              return this.handleEvent(val, 'audit')
            },
            isShow:
              this.$hasAccess('audit') &&
              (val.hiddenDangerRectificationStatus === 4 ||
                val.hiddenDangerRectificationStatus === 3) && val.auditPermission,
          },
          {
            text: '驳回',
            click: () => {
              return this.handleEvent(val, 'rectification')
            },
            isShow:
              this.$hasAccess('rectification') &&
              val.hiddenDangerRectificationStatus !== 4 &&
              val.auditPermission,
          },
          // 不变
          {
            text: '申请验收',
            click: () => {
              return this.handleEvent(val, 'accpet')
            },
            isShow:
              this.$hasAccess('accpet') &&
              (val.hiddenDangerRectificationStatus === 1 ||
              val.hiddenDangerRectificationStatus === 3) &&
              val.auditPermission,
          },
          {
            text: '申请延期',
            click: () => {
              return this.handleEvent(val, 'delay')
            },
            isShow:
              this.$hasAccess('delay') &&
              val.auditPermission &&
              (val.hiddenDangerRectificationStatus === 1 ||
                val.hiddenDangerRectificationStatus === 3),
          },
          // {
          //   text: '超期未整改延期',
          //   click: () => {
          //     return this.handleEvent(val, 'delay')
          //   },
          //   isShow: this.$hasAccess('delay') && val.hiddenDangerRectificationStatus === 3,
          // },
          // 不变
          // 不变
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  created() {
    const id = this.$route.query.id
    const taskId = this.$route.query.taskId
    if (id && this.$route.query.mode) {
      this.initDialog({ id, taskId }, this.$route.query.mode === 'approve' ? 'approve' : 'read')
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
    this.searchList()
    this.getAreaList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.rectificationTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.rectificationTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.rectificationTimeStart = ''
        this.searchData.rectificationTimeEnd = ''
      }
    },
  },
  methods: {
    // handleDialog(row, type) {
    //   this.FormData = row
    //   // 整改
    //   if (type === 'rectification') {
    //     this.showForm = true
    //   }
    //   // 延期
    //   if (type === 'delay') {
    //     this.showDelayForm = true
    //   }
    // },
    handleDelayFormOk() {
      this.findList()
      this.showDelayForm = false
    },
    handleFormOk(row) {
      // 开始整改后变成进行验收操作
      // const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
      this.showForm = false
      this.findList()
      this.initDialog(this.FormData, 'accpet')
    },

    async handleRejectOk(reason) {
      // 驳回
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationOverrule({
        body: {
          id: this.FormData.id,
          currentWorkflowTaskId: this.FormData.currentWorkflowTaskId,
          rejectionReasons: reason,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '驳回成功',
          type: 'success',
        })
        this.findList()
      }
      this.showDialog = false
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      // 低代码
      if (window.__POWERED_BY_QIANKUN__) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res1 = await instance.get(
          `/api/double-prevention-management/hidden-danger-rectification-checklists/paged-rectification-list-query?${qs.stringify(
            data
          )}`
        )
        if (res1.status === 200 && res1.data) {
          this.tableData = res1.data.items
          this.total = res1.data.totalCount
          this.loading = false
        }
        return
      }
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    refreshList() {
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        // 查看
        case 'read':
          this.initDialog(row, operation)
          break
        // 整改/驳回
        case 'rectification':
          this.initDialog(row, operation)
          break
        // 整改单
        case 'single':
          this.initDialog(row, operation)
          break
        // 审核/验收
        default:
          this.initDialog(row, operation)
          break
      }
    },
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'read' ? '查看' : '编辑'
      }隐患整改`
      if (operation === 'create') {
        this.FormData = this.$options.data().FormData
      } else {
        let resVal = {}
        if (window.__POWERED_BY_QIANKUN__) {
          // 低代码
          const instance = axios.create()
          instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
          const token = localStorage.getItem('authorization')
          instance.defaults.headers.common.Authorization = `Bearer ${token}`
          const result = await instance.get(
            `api/double-prevention-management/hidden-danger-rectification-checklists/${row.id}`
          )
          if (result.status === 200 && result.data) {
            resVal = result.data
          }
        } else {
          const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
          if (!err) {
            resVal = res
          }
        }
        if (row.workflowTaskId) {
          resVal.workflowTaskId = row.workflowTaskId
        }
        if (row.currentWorkflowTaskId) {
          resVal.currentWorkflowTaskId = row.currentWorkflowTaskId
        }
        if (row.currentWorkflowDelayTaskId) {
          resVal.currentWorkflowDelayTaskId = row.currentWorkflowDelayTaskId
        }
        // 开始整改后防止状态没有改变
        if (operation === 'accpet') {
          resVal.hiddenDangerRectificationStatus = 1
        }
        // 兼容和待办
        if (this.$route.query.id) {
          // 判断审核类型给正确的流程id
          if (resVal.hiddenDangerRectificationStatus === 4 && this.$route.query.isdelay === '1') {
            // 延期审核
            resVal.currentWorkflowDelayTaskId = row.taskId
          } else {
            resVal.currentWorkflowTaskId = row.taskId
          }
        }
        this.FormData = resVal
      }
      if (operation === 'delay') {
        this.showDelayForm = true
        return
      }
      if (operation === 'single') {
        this.isSingle = true
      } else {
        this.formDialog = true
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
